function getMessage(field, args) {
  return `The ${field} field must contain a valid NRIC number.`
}

function validate(value, args) {
  if (value) {
    if (checkValidNRIC(value)) {
      return true
    } else {
      return false
    }
  } else return false
}

function checkValidNRIC(nric) {
  if (nric.length !== 9) {
    return false
  }

  // if not a valid prefix, return false
  var prefix = nric.charAt(0).toUpperCase()
  if (prefix !== 'S' && prefix !== 'T' && prefix !== 'F' && prefix !== 'G') {
    return false
  }

  var uin = ['J', 'Z', 'I', 'H', 'G', 'F', 'E', 'D', 'C', 'B', 'A']
  var fin = ['X', 'W', 'U', 'T', 'R', 'Q', 'P', 'N', 'M', 'L', 'K']
  var weightArray = [2, 7, 6, 5, 4, 3, 2]
  var weight = 0
  var lastAlphabet = null

  nric = nric.toUpperCase()

  var icArray = nric.split('')

  // return false if position 2-8 of nric is not a number
  try {
    for (var i = 1; i < 8; i++) {
      weight += parseInt(icArray[i], 10) * weightArray[i - 1]
    }
  } catch (ex) {
    return false
  }

  // calculate last alphabet
  var offset = (icArray[0] === 'T' || icArray[0] === 'G') ? 4 : 0
  var temp = (offset + weight) % 11

  if (icArray[0] === 'S' || icArray[0] === 'T') {
    lastAlphabet = uin[temp]
  } else if (icArray[0] === 'F' || icArray[0] === 'G') {
    lastAlphabet = fin[temp]
  }

  return (icArray[8] === lastAlphabet)
}

export default {
  getMessage,
  validate
}
